module.exports = __webpack_public_path__ + "static/media/gabbys-bistro.51e09536.jpg";